import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Button,
  Box,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Snackbar,
  Alert,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TablaInscripciones from './TablaInscripciones';

const StepPago = ({ handleBack, formData, handleReset, onEnviarInscripcion, success = false, receiptData = null }) => {
  const [paymentMethod, setPaymentMethod] = useState('enLinea');
  const [registroExitoso, setRegistroExitoso] = useState(false);

  // Snackbar local (si te sirve para feedback de este paso)
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const handleCloseSnackbar = (e, r) => { if (r !== 'clickaway') setSnackbarOpen(false); };

  const handlePaymentChange = (event) => setPaymentMethod(event.target.value);

  // Dispara el submit del padre (formik.onSubmit dentro de RegistroForm)
  const handleEnviar = async () => {
    // si quieres que paymentMethod viaje en el submit, puedes setearlo en formik antes de enviar
    // (o agregarlo en RegistroForm.onSubmit leyendo de algún estado global/contexto)
    if (typeof onEnviarInscripcion === 'function') {
      await onEnviarInscripcion(); // <- llama a formik.handleSubmit() que ya guarda correctamente
    }
  };

  const handleRegresar = () => {
    handleReset?.();
  };

  // Éxito: controlado por prop o por estado local
  if (success || registroExitoso) {
    return (
      <Box p={2}>
        <Grid container spacing={2} justifyContent="center" alignItems="center" direction="column">
          <Grid item>
            <CheckCircleIcon color="primary" style={{ fontSize: 60 }} />
          </Grid>
          <Grid item>
            <Typography variant="h6" color="primary">
              Registro Exitoso
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" gutterBottom>
              La inscripción se realizó correctamente. A continuación se muestran los datos registrados:
            </Typography>
          </Grid>
          <Grid item>
            <TablaInscripciones
              datos={{ ...(receiptData || formData), paymentMethod }}
              onEnviarCorreo={() => console.log('Enviar correo')}
            />
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleRegresar}>
              Regresar
            </Button>
          </Grid>
        </Grid>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    );
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Información de Pago</Typography>
        </Grid>

        <Grid item xs={12}>
          <FormControl component="fieldset">
            <RadioGroup row name="paymentMethod" value={paymentMethod} onChange={handlePaymentChange}>
              <FormControlLabel value="enLinea" control={<Radio />} label="Pago en línea" />
              <FormControlLabel value="diaEvento" control={<Radio />} label="Pago el día del evento" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {paymentMethod === 'diaEvento' ? (
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              Al seleccionar esta forma de pago, tendrás que llevar tu comprobante de inscripción el día acordado en la convocatoria y efectuar el pago de manera presencial.
            </Typography>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              (Aquí se mostrarán los campos para ingresar la información de pago y cargar el comprobante)
            </Typography>
          </Grid>
        )}

        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
            <Button onClick={handleBack} variant="outlined">
              Anterior
            </Button>
            <Button variant="contained" color="primary" onClick={handleEnviar}>
              Enviar Inscripción
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default StepPago;
